import binance from "./assets/sources/binance-icon.svg";
import aster from "./assets/sources/aster.svg";
import bnb from "./assets/sources/bnb.svg";
import btc from "./assets/sources/btc.png";
import solana from "./assets/sources/solana.svg";
import moomoo from "./assets/sources/moomoo.png";
import tiger from "./assets/sources/tiger.png";

/** @typedef {{ id: string, icon: string }} PortfolioReserveSource */

/** @type {Record<string, PortfolioReserveSource[]>} */
export const PORTFOLIO_RESERVE_SOURCES = {
  unitas: [
    { id: "binance", icon: binance },
    { id: "aster", icon: aster },
    { id: "btc", icon: btc },
    { id: "solana", icon: solana },
    { id: "bnb", icon: bnb },
  ],
  unitasXgld: [
    { id: "binance", icon: binance },
    { id: "bnb", icon: bnb },
  ],
  rwalpha: [
    { id: "moomoo", icon: moomoo },
    { id: "tiger", icon: tiger },
  ],
};
